import { render, staticRenderFns } from "./TabMain.vue?vue&type=template&id=35228546&"
import script from "./TabMain.vue?vue&type=script&lang=js&"
export * from "./TabMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports